import { useResourceContext, useTranslate } from "react-admin";

export const useTranslatedInputLabel = (props) => {
    const translate = useTranslate();
    const resource = useResourceContext(props);

    if (props.label) {
        return translate(props.label, { _: props.label });
    }

    if (props.source && resource) {
        return translate(`resources.${resource}.fields.${props.source}`, { _: props.source });
    }

    return undefined;
};
